/**
 * Que mensagem de ALERTA ganha o cartão de proposta.
 *
 * O cartão nasce na resposta do @Atendente (`kind='bot'`). Duas mensagens que o
 * SERVIDOR escreve como `kind='alert'` também carregam um cartão no
 * `metadata.proposed_action`:
 *
 * - O aviso da retomada da conta, quando abre o rascunho em branco, traz o cartão do
 *   formulário (consoleai#25071) — antes ele mandava responder "abra o formulário" e o
 *   cartão dependia de o modelo escolher a ferramenta certa (conversa 851879,
 *   27/10/2026: não escolheu). Ele não confirma nada: abre o wizard, com os portões do
 *   servidor.
 * - O cartão de decisão do pedido de Terraform (spec 2026-11-04-painel-do-devops D-2):
 *   quando o plan fica pronto (`aguardando_confirmacao`) ou o pedido vai para
 *   `aguardando_pedinte`, o servidor escreve no fim da conversa uma CÓPIA do
 *   `proposed_action` do cartão do pedido (`terraform_adjust`/`terraform_ajuste_livre`,
 *   com `params.pedido_id`). O clique passa pelo `confirm_endpoint` de hoje, que vale
 *   pelo ESTADO do pedido e não pelo `status` da mensagem.
 *
 * Nada além disso: alerta do motor carrega o `source_meta` do evento no metadata, e um
 * `proposed_action` de outro tipo vindo por ali não vira botão. O do pedido só vale com
 * `pedido_id` numérico — sem ele não há pedido para o cartão ler.
 */
import type { ProposedAction } from './components/ActionProposalCard'

export const CARTAO_DO_FORMULARIO = 'abrir_formulario_de_ambiente'

/** O `pedido_id` do cartão de pedido de Terraform; `null` em qualquer outro cartão. */
export function pedidoDoCartao(proposedAction: ProposedAction | null): number | null {
  const tipo = proposedAction?.action_type
  if (tipo !== 'terraform_adjust' && tipo !== 'terraform_ajuste_livre') return null
  const id = (proposedAction!.params as Record<string, unknown> | null | undefined)?.pedido_id
  return typeof id === 'number' && Number.isInteger(id) ? id : null
}

export function cartaoDoAviso(kind: string, proposedAction: ProposedAction | null): boolean {
  if (kind !== 'alert' || !proposedAction) return false
  if (proposedAction.action_type === CARTAO_DO_FORMULARIO) return true
  return pedidoDoCartao(proposedAction) !== null
}
